/**
 * Shared Tailwind class strings for canvas node UI standardization.
 * Single source of truth — import these instead of defining inline.
 *
 * NOTE: This project's Tailwind config has NO `DEFAULT` borderRadius,
 * so plain `rounded` does nothing. Always use `rounded-md` (6px).
 */

// ─── Form Elements ───────────────────────────────────────────────────────────

export const NODE_SELECT_CLASS =
  'w-full text-xs border border-gray-200 rounded-md px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-400';

export const NODE_SELECT_COMPACT_CLASS =
  'w-full text-xs border border-gray-200 rounded-md px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-400';

export const NODE_INPUT_CLASS =
  'w-full text-xs border border-gray-200 rounded-md px-2 py-1 bg-white focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-400';

export const NODE_TEXTAREA_CLASS =
  'w-full text-sm border border-gray-200 rounded-md p-2 resize-y focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-400 nodrag';

// ─── Labels ──────────────────────────────────────────────────────────────────

export const NODE_LABEL_CLASS = 'text-[11px] text-gray-500 font-medium block mb-1';

export const NODE_LABEL_COMPACT_CLASS = 'text-[11px] text-gray-500 font-medium block mb-1';

// ─── Pills / Badges ─────────────────────────────────────────────────────────

export const NODE_PILL_CLASS = 'text-[10px] px-1.5 py-px rounded-md font-semibold leading-none';

// ─── Indicators ──────────────────────────────────────────────────────────────

export const NODE_INFO_CLASS =
  'text-xs p-2 rounded-md border border-info-200 bg-info-50 text-info-700';

export const NODE_WARNING_CLASS =
  'text-xs p-2 rounded-md border border-warning-200 bg-warning-50 text-warning-700';

export const NODE_WARNING_COMPACT_CLASS =
  'text-[11px] px-2 py-1.5 rounded-md border border-warning-300 bg-warning-50 text-warning-700 leading-snug';

export const NODE_ERROR_CLASS =
  'text-xs p-2 rounded-md border border-error-200 bg-error-50 text-error-700';

// ─── Tips / Hints ───────────────────────────────────────────────────────────

export const NODE_TIP_CLASS =
  'text-[10px] text-gray-400 bg-gray-50 px-1.5 py-1 rounded-md border border-gray-100 leading-tight';
